import script from "./TodaysSouvenirScoreInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./TodaysSouvenirScoreInfo.vue?vue&type=script&setup=true&lang=ts"

import "./TodaysSouvenirScoreInfo.vue?vue&type=style&index=0&id=0ddb3a3b&lang=scss&scoped=true"

import exportComponent from "/Users/min_zero/Desktop/haii/projects/alzguard-app-web-at/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ddb3a3b"]])

export default __exports__
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QImg});
